import { loadStripe } from "@stripe/stripe-js";

const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!publishableKey) {
  console.warn(
    "[stripe] VITE_STRIPE_PUBLISHABLE_KEY is not set. Payment features will not work.",
  );
}

export const stripePromise = publishableKey ? loadStripe(publishableKey) : null;
